import { useCallback } from 'react';
import {
  useGetUserAllowedOrganizationOfferGroups,
  useListBobcatOfferGroups,
} from '@/api/trafikportalen';
import { staticTicketTitle } from '@/helpers/staticTicket';

export const useTenantStaticTicketTitles = () => {
  const { data } = useListBobcatOfferGroups();
  return useCallback(
    (stinaProductId?: string) =>
      staticTicketTitle(
        stinaProductId,
        data?.filter((offer) => offer.sales_channel === 'school'),
      ),
    [data],
  );
};

export const useOrganizationStaticTicketTitles = (collectionType?: string) => {
  const { data } = useGetUserAllowedOrganizationOfferGroups();
  return useCallback(
    (stinaProductId?: string) =>
      staticTicketTitle(stinaProductId, data, collectionType),
    [collectionType, data],
  );
};
